export default function SectionApp() {
  return (
    <section id="app" className="bg-background-100 py-16 md:py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 whitespace-nowrap mb-3">
              移动观影
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              随时随地，掌上观影
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              7777影院移动端已全面适配。无需下载APP，浏览器直接访问即可享受与桌面端一致的高清观影体验。支持手势控制亮度和音量，横竖屏自由切换，地铁通勤、午休间隙，好片随时继续。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">
                <i className="ri-android-line text-lg"></i>
                Android 版
              </button>
              <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">
                <i className="ri-apple-line text-lg"></i>
                iOS 版
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-xs lg:max-w-sm">
            <div className="relative w-full aspect-[9/16] max-h-[500px] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%2C%20dark%20cinematic%20UI%20design%2C%20warm%20red%20and%20gold%20accent%20colors%2C%20clean%20minimal%20layout%2C%20professional%20app%20mockup%2C%20movie%20recommendation%20screen&width=600&height=1067&seq=app-mockup-7777-v2&orientation=portrait"
                alt="7777影院移动端界面 - 随时随地掌上观影"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}